import { render, staticRenderFns } from "./logoHomeYinDu.vue?vue&type=template&id=53037189&scoped=true&"
import script from "./logoHomeYinDu.vue?vue&type=script&lang=js&"
export * from "./logoHomeYinDu.vue?vue&type=script&lang=js&"
import style0 from "./logoHomeYinDu.vue?vue&type=style&index=0&id=53037189&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53037189",
  null
  
)

export default component.exports